class ct_shoppingbag extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => {
      const cart = document.querySelector("ct-cart-drawer");
      cart.toggleDrawer();
    });
  }
  refresh() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        const bubble = this.querySelector(".ct-shopbag-counter");
        const countItem = bubble.querySelector("span");
        countItem.innerText = data.item_count;
        return data;
      });
  }
}

customElements.define("ct-shoppingbag", ct_shoppingbag);